"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var BaseController_1 = require("../../../../../../shared/controllers/BaseController");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var webAApi_1 = require("../../../../../api/webAApi");
var BonusTournamentsPrizesListCtl = /** @class */ (function (_super) {
    __extends(BonusTournamentsPrizesListCtl, _super);
    function BonusTournamentsPrizesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_app_currency_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_id; });
        _this.dk_app_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_title; });
        _this.dk_prize_place_number = UIUtils_1.UIUtils.IProp2Str(function (o) { o.prize_place_number; });
        _this.dk_prize_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.prize_type_code; });
        _this.dk_prize_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.prize_type_title; });
        _this.dk_bonus_template_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_template_id; });
        _this.dk_bonus_template_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_template_title; });
        _this.dk_bonus_dream_text_val = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_dream_text_val; });
        _this.dk_bonus_points_prize_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_points_prize_amount; });
        _this.dk_bonus_cash_prize_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_cash_prize_amount; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this.dk_is_bonus = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_bonus; });
        _this.dk_is_points = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_points; });
        _this.dk_is_cash = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_cash; });
        _this.dk_is_dream = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_dream; });
        _this._errDialog = errDialog;
        return _this;
    }
    BonusTournamentsPrizesListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    BonusTournamentsPrizesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "object with id [" + id + "] not found !";
    };
    BonusTournamentsPrizesListCtl.prototype.LoadData = function (bonusTournamentId, onDone) {
        var _this = this;
        webAApi_1.ListTournamentPrizesByTournamentIdGet.exec({
            bonus_tournament_id: bonusTournamentId
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    app_currency_id: resp.list[i].app_currency_id,
                    app_currency_title: resp.list[i].app_currency_title,
                    prize_place_number: resp.list[i].prize_place_number,
                    prize_type_code: resp.list[i].prize_type_code,
                    prize_type_title: resp.list[i].prize_type_title,
                    bonus_template_id: resp.list[i].bonus_template_id,
                    bonus_template_title: resp.list[i].bonus_template_title,
                    bonus_points_prize_amount: resp.list[i].bonus_points_prize_amount,
                    bonus_cash_prize_amount: resp.list[i].bonus_cash_prize_amount,
                    bonus_dream_text_val: resp.list[i].bonus_dream_text_val,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    description: resp.list[i].description,
                    is_bonus: resp.list[i].is_bonus,
                    is_points: resp.list[i].is_points,
                    is_cash: resp.list[i].is_cash,
                    is_dream: resp.list[i].is_dream
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BonusTournamentsPrizesListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddTournamentPrize.exec({
            data: {
                bonus_tournament_id: data.bonus_tournament_id,
                app_currency_id: data.app_currency_id,
                prize_place_number: data.prize_place_number,
                prize_type_code: data.prize_type_code,
                bonus_template_id: data.bonus_template_id,
                bonus_points_prize_amount: data.bonus_points_prize_amount,
                bonus_cash_prize_amount: data.bonus_cash_prize_amount,
                bonus_dream_text_val: data.bonus_dream_text_val,
                description: data.description
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                app_currency_id: data.app_currency_id,
                app_currency_title: resp.app_currency_title,
                prize_place_number: data.prize_place_number,
                prize_type_code: data.prize_type_code,
                prize_type_title: resp.prize_type_title,
                bonus_template_id: data.bonus_template_id,
                bonus_template_title: resp.bonus_template_title,
                bonus_points_prize_amount: data.bonus_points_prize_amount,
                bonus_cash_prize_amount: data.bonus_cash_prize_amount,
                bonus_dream_text_val: data.bonus_dream_text_val,
                date_changed2: moment(resp.date_changed_uts_ms).utc(false),
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                description: data.description,
                is_bonus: resp.is_bonus,
                is_points: resp.is_points,
                is_cash: resp.is_cash,
                is_dream: resp.is_dream
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BonusTournamentsPrizesListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditTournamentPrize.exec({
                data: {
                    bonus_tournament_prize_id: data.key,
                    app_currency_id: data.app_currency_id,
                    prize_place_number: data.prize_place_number,
                    prize_type_code: data.prize_type_code,
                    bonus_template_id: data.bonus_template_id,
                    bonus_points_prize_amount: data.bonus_points_prize_amount,
                    bonus_cash_prize_amount: data.bonus_cash_prize_amount,
                    bonus_dream_text_val: data.bonus_dream_text_val,
                    description: data.description
                }
            }, function (resp) {
                _tmp.app_currency_id = data.app_currency_id;
                _tmp.app_currency_title = resp.app_currency_title;
                _tmp.prize_place_number = data.prize_place_number;
                _tmp.prize_type_code = data.prize_type_code;
                _tmp.prize_type_title = resp.prize_type_title;
                _tmp.bonus_template_id = data.bonus_template_id;
                _tmp.bonus_template_title = resp.bonus_template_title;
                _tmp.bonus_points_prize_amount = data.bonus_points_prize_amount;
                _tmp.bonus_cash_prize_amount = data.bonus_cash_prize_amount;
                _tmp.bonus_dream_text_val = data.bonus_dream_text_val;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.description = data.description;
                _tmp.is_bonus = resp.is_bonus;
                _tmp.is_points = resp.is_points;
                _tmp.is_cash = resp.is_cash;
                _tmp.is_dream = resp.is_dream;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BonusTournamentsPrizesListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    BonusTournamentsPrizesListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteTournamentPrize.exec({
                data: {
                    bonus_tournament_prize_id: key
                }
            }, function (resp) {
                _this.RemoveItem(key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return BonusTournamentsPrizesListCtl;
}(BaseController_1.BaseController));
exports.BonusTournamentsPrizesListCtl = BonusTournamentsPrizesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_tournament/ctl/options/BonusTournamentsPrizesListCtl.ts
// module id = 1019
// module chunks = 0